import { IRetailer } from 'shared/types';
import { IAuthorizedTab, ICompanyInfo, IInternationalCompany, IUserInfo } from 'types';
import { cdmApi } from '.';

const PREFIX = `${process.env.REACT_APP_CDM_API}/api/auth/user`;

const authApi = cdmApi.injectEndpoints({
    endpoints: (builder) => ({
        getUserInfo: builder.query<
            {
                code: number;
                user: {
                    user: {
                        original_user: string;
                    };
                    companyInfo: ICompanyInfo;
                    userInfo: IUserInfo;
                    authorizedTabs: IAuthorizedTab[];
                    tools: number[];
                };
            },
            void
        >({ query: () => ({ url: `${PREFIX}/info`, method: 'get' }) }),
        getRetailerByClient: builder.query<{ code: number; data: IRetailer[] }, void>({
            query: () => ({ url: `${PREFIX}/retailer`, method: 'get' }),
        }),
        getInternationalCompanies: builder.query<
            { code: number; internationalCompanies: IInternationalCompany[] },
            void
        >({
            query: () => ({ url: `${PREFIX}/international-companies`, method: 'GET' }),
        }),
        updateUserCompany: builder.mutation<{ code: number; status: any }, { id: string }>({
            query: (data) => ({ url: `${PREFIX}/company`, method: 'PUT', data }),
            async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
                const { data } = await queryFulfilled;
                if (data.code === 200) {
                    dispatch(cdmApi.util.resetApiState());
                }
            },
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetUserInfoQuery,
    useGetRetailerByClientQuery,
    useLazyGetUserInfoQuery,
    useGetInternationalCompaniesQuery,
    useUpdateUserCompanyMutation,
} = authApi;
